import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';

const ContactHero = () => {
  const { t } = useTranslation();
  
  return (
    <section className="relative bg-gradient-to-br from-primary via-primary/95 to-primary/90 text-primary-foreground overflow-hidden">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNnoiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLW9wYWNpdHk9Ii4xIi8+PC9nPjwvc3ZnPg==')] opacity-20"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-12 md:py-16 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="space-y-4 md:space-y-6">
            <div className="inline-flex items-center gap-2 px-3 md:px-4 py-1.5 md:py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20">
              <Icon name="MessageSquare" size={16} className="text-accent" />
              <span className="text-xs md:text-sm font-medium">{t('contact.hero.badge')}</span>
            </div>
            
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-headline leading-tight">
              {t('contact.hero.title')}
            </h1>
            
            <p className="text-base md:text-lg lg:text-xl text-primary-foreground/90 leading-relaxed">
              {t('contact.hero.subtitle')}
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4 pt-4">
              <div className="flex items-center gap-3 p-3 md:p-4 bg-white/10 backdrop-blur-sm rounded-lg border border-white/20">
                <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 bg-accent/20 rounded-lg flex items-center justify-center">
                  <Icon name="Clock" size={20} className="text-accent" />
                </div>
                <div>
                  <div className="text-xl md:text-2xl font-bold font-headline">24h</div>
                  <div className="text-xs md:text-sm text-primary-foreground/80">{t('contact.hero.responseTime')}</div>
                </div>
              </div>
              
              <div className="flex items-center gap-3 p-3 md:p-4 bg-white/10 backdrop-blur-sm rounded-lg border border-white/20">
                <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 bg-secondary/20 rounded-lg flex items-center justify-center">
                  <Icon name="Globe" size={20} className="text-secondary" />
                </div>
                <div>
                  <div className="text-xl md:text-2xl font-bold font-headline">15+</div>
                  <div className="text-xs md:text-sm text-primary-foreground/80">{t('contact.hero.languages')}</div>
                </div>
              </div>
              
              <div className="flex items-center gap-3 p-3 md:p-4 bg-white/10 backdrop-blur-sm rounded-lg border border-white/20">
                <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 bg-success/20 rounded-lg flex items-center justify-center">
                  <Icon name="Shield" size={20} className="text-success" />
                </div>
                <div>
                  <div className="text-xl md:text-2xl font-bold font-headline">100%</div>
                  <div className="text-xs md:text-sm text-primary-foreground/80">{t('contact.hero.fifaCompliant')}</div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="relative hidden lg:block">
            <div className="absolute inset-0 bg-gradient-to-br from-accent/20 to-secondary/20 rounded-2xl blur-3xl"></div>
            <div className="relative bg-white/10 backdrop-blur-md rounded-2xl border border-white/20 p-6 md:p-8 space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-success/20 rounded-full flex items-center justify-center">
                  <Icon name="CheckCircle2" size={24} className="text-success" />
                </div>
                <div>
                  <div className="text-sm text-primary-foreground/80">{t('contact.hero.averageResponse')}</div>
                  <div className="text-2xl font-bold font-headline">{t('contact.hero.underHours')}</div>
                </div>
              </div>
              
              <div className="h-px bg-white/20"></div>
              
              <div className="space-y-3">
                <div className="flex items-center gap-2">
                  <Icon name="Check" size={16} className="text-success" />
                  <span className="text-sm">{t('contact.hero.directAccess')}</span>
                </div>
                <div className="flex items-center gap-2">
                  <Icon name="Check" size={16} className="text-success" />
                  <span className="text-sm">{t('contact.hero.videoConsultation')}</span>
                </div>
                <div className="flex items-center gap-2">
                  <Icon name="Check" size={16} className="text-success" />
                  <span className="text-sm">{t('contact.hero.multilingualSupport')}</span>
                </div>
                <div className="flex items-center gap-2">
                  <Icon name="Check" size={16} className="text-success" />
                  <span className="text-sm">{t('contact.hero.secureDocumentSharing')}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;